






































import { Component, Prop, Vue } from 'vue-property-decorator';
import ChangedDocumentStatusSendToAllianzViewModel
  from '@/vue-app/view-models/allianz-dashboard/allianz-actions/changed-document-status/changed-document-status-send-to-allianz-view-model';

@Component({ name: 'ChangedDocumentStatusSendToAllianz' })
export default class ChangedDocumentStatusSendToAllianz extends Vue {
  @Prop(String)
  document_type!: string;

  send_to_allianz_view_model = Vue.observable(
    new ChangedDocumentStatusSendToAllianzViewModel(),
  );

  mounted() {
    this.send_to_allianz_view_model.initialize(this.document_type);
  }

  closeModal() {
    this.$emit('closeDialog');
  }
}
